module.exports = __webpack_public_path__ + "img/logo_login-1.e6709924.png";